<div class="g-ui-grid-page">
    <div class="g-ui-grid-page__grid">
        <app-ui-grid [uiGridOptions]="gridOptions"></app-ui-grid>
    </div>
</div>
